import {DataFetcher} from '@aboutyou/data-fetcher';
import React, {FC} from 'react';
import {useBasketTotalsSection} from '../hooks/useGetBasketPageSection';
import {BasketTotalSkeleton} from './BasketTotal.skeleton';
import {BasketTotalView, BasketTotalViewProps} from './BasketTotalView';

export const BasketTotal: FC<BasketTotalViewProps> = props => {
  return (
    <DataFetcher
      request={useBasketTotalsSection()}
      Error={null}
      View={BasketTotalView}
      Loading={BasketTotalSkeleton}
      viewProps={props}
    />
  );
};
